// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Route } from 'react-router-dom';

const UnAuthRoute = ({ auth, userType, ...props }) => {
  const isAuthenticated = auth && auth.isAuthenticated;
  return !isAuthenticated ? <Route {...props} /> : null;
};

export default UnAuthRoute;
